// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Renk Paleti =====
   #1C0770 - Koyu mor/mavi (primary dark)
   #261CC1 - Mavi (primary)
   #3A9AFF - Açık mavi (secondary accent)
   #F1FF5E - Sarı/limon (accent, vurgu)
*/

/* Light Mode (varsayılan) */
.landing {
  --color-primary-dark: #1c0770;
  --color-primary: #261cc1;
  --color-secondary: #3a9aff;
  --color-accent: #f1ff5e;
  --color-accent-text: #1a1a2e;

  --bg-main: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 50%, #f5f9ff 100%);
  --bg-header: rgba(255, 255, 255, 0.85);
  --bg-card: rgba(255, 255, 255, 0.9);
  --bg-card-hover: rgba(255, 255, 255, 1);
  --bg-cta: rgba(58, 154, 255, 0.12);
  --bg-footer: rgba(28, 7, 112, 0.08);

  --text-primary: #1a1a2e;
  --text-secondary: #4a4a6a;
  --text-muted: #6b6b8a;

  --border-card: rgba(38, 28, 193, 0.12);
  --shadow-card: 0 4px 24px rgba(28, 7, 112, 0.08);
  --shadow-card-hover: 0 8px 32px rgba(38, 28, 193, 0.15);
}

/* Dark Mode */
.landing[data-theme="dark"] {
  --color-primary-dark: #5b4dff;
  --color-primary: #6b5cff;
  --color-secondary: #3a9aff;
  --color-accent: #f1ff5e;
  --color-accent-text: #0f0f14;

  --bg-main: linear-gradient(135deg, #0f0f14 0%, #1a1a24 50%, #15151f 100%);
  --bg-header: rgba(26, 26, 36, 0.9);
  --bg-card: rgba(37, 37, 48, 0.8);
  --bg-card-hover: rgba(45, 45, 60, 0.95);
  --bg-cta: rgba(58, 154, 255, 0.15);
  --bg-footer: rgba(0, 0, 0, 0.3);

  --text-primary: #f0f0f5;
  --text-secondary: #b8b8c8;
  --text-muted: #8888a0;

  --border-card: rgba(255, 255, 255, 0.08);
  --shadow-card: 0 4px 24px rgba(0, 0, 0, 0.3);
  --shadow-card-hover: 0 8px 32px rgba(58, 154, 255, 0.12);
}

/* Base */
.landing {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-main);
  transition: background 0.3s ease;
}

/* Header */
.landing-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background: var(--bg-header);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-card);
  transition:
    background 0.3s ease,
    border-color 0.3s ease;
}

.landing-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.landing-logo:hover {
  opacity: 0.9;
}

.landing-logo-img {
  height: 40px;
  width: auto;
  object-fit: contain;
  display: block;
}

.landing-nav {
  display: flex;
  gap: 12px;
  align-items: center;
}

.nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s;
}

.nav-link:hover {
  color: var(--color-primary);
  background: var(--bg-cta);
}

.nav-link--primary {
  background: var(--color-primary);
  color: white;
}

.nav-link--primary:hover {
  background: var(--color-primary-dark);
  color: white;
}

/* Language Selector */
.lang-selector {
  position: relative;
}

.lang-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--border-card);
  border-radius: 10px;
  background: var(--bg-card);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.lang-trigger:hover {
  border-color: var(--color-secondary);
  background: var(--bg-cta);
}

.lang-trigger-flag {
  font-size: 18px;
}

.lang-trigger-arrow {
  font-size: 10px;
  opacity: 0.7;
  transition: transform 0.2s;
}

.lang-selector--open .lang-trigger-arrow {
  transform: rotate(180deg);
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 180px;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: var(--bg-card);
  border: 1px solid var(--border-card);
  border-radius: 12px;
  box-shadow: var(--shadow-card-hover);
  z-index: 100;
}

.lang-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.lang-option:hover {
  background: var(--bg-cta);
}

.lang-option--active {
  background: var(--bg-cta);
  color: var(--color-primary);
  font-weight: 600;
}

/* RTL (Arapça) */
.landing--rtl .lang-trigger,
.landing--rtl .lang-option {
  text-align: right;
}

.landing--rtl .lang-dropdown {
  left: auto;
  right: 0;
}

.landing--rtl .hero-title-accent {
  margin-left: 0;
  margin-right: 4px;
}

/* Theme Toggle */
.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: var(--bg-cta);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
}

.theme-toggle:hover {
  background: var(--color-secondary);
  color: white;
}

/* Main */
.landing-main {
  flex: 1;
  padding: 60px 40px 80px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* Body seviyesinde animasyonlu arka plan - slogan alanına denk, yumuşak geçişle biter */
.landing-page-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 75vh;
  max-height: 720px;
  pointer-events: none;
  z-index: 10;
  /* Keskin çizgi yerine profesyonel yumuşak geçiş */
  mask-image: linear-gradient(
    to bottom,
    black 0%,
    black 35%,
    rgba(0, 0, 0, 0.85) 55%,
    rgba(0, 0, 0, 0.5) 75%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    black 0%,
    black 35%,
    rgba(0, 0, 0, 0.85) 55%,
    rgba(0, 0, 0, 0.5) 75%,
    transparent 100%
  );
}

/* Hero */
.hero {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 40px 0 80px;
}

/* Işık ışınları - yukarıdan düşen ışık efekti */
.hero-light-rays {
  position: absolute;
  inset: -30% -30% -30% -30%;
  background:
    /* Ana ışık konisi - yukarıdan aşağı */
    radial-gradient(
      ellipse 120% 80% at 50% -20%,
      rgba(58, 154, 255, 0.18) 0%,
      rgba(38, 28, 193, 0.08) 30%,
      transparent 65%
    ),
    /* Yan ışık şeritleri */
    linear-gradient(
        105deg,
        transparent 26%,
        rgba(58, 154, 255, 0.12) 38%,
        transparent 50%
      ),
    linear-gradient(
      75deg,
      transparent 21%,
      rgba(38, 28, 193, 0.09) 33%,
      transparent 45%
    ),
    linear-gradient(
      90deg,
      transparent 16%,
      rgba(241, 255, 94, 0.06) 28%,
      transparent 40%
    ),
    linear-gradient(
      120deg,
      transparent 31%,
      rgba(58, 154, 255, 0.08) 43%,
      transparent 55%
    );
  animation: lightRaysMove 7s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  opacity: 0.9;
}

@keyframes lightRaysMove {
  0% {
    transform: translateY(-15%) rotate(-3deg) scale(1.06);
    opacity: 0.75;
  }
  18% {
    transform: translateY(8%) rotate(4deg) scale(1.14);
    opacity: 0.95;
  }
  38% {
    transform: translateY(2%) rotate(-1deg) scale(1.08);
    opacity: 0.85;
  }
  58% {
    transform: translateY(15%) rotate(2deg) scale(1.12);
    opacity: 0.95;
  }
  78% {
    transform: translateY(-5%) rotate(-2deg) scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: translateY(-15%) rotate(-3deg) scale(1.06);
    opacity: 0.75;
  }
}

/* Parlayan orb'lar - yumuşak hareketli ışık noktaları */
.hero-glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.45;
  animation: orbFloat 5.5s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

.hero-glow-orb--1 {
  width: 320px;
  height: 320px;
  background: radial-gradient(
    circle,
    rgba(58, 154, 255, 0.35) 0%,
    rgba(38, 28, 193, 0.15) 40%,
    transparent 70%
  );
  top: -100px;
  left: 10%;
  animation-delay: 0s;
}

.hero-glow-orb--2 {
  animation-delay: -0.9s;
  width: 260px;
  height: 260px;
  background: radial-gradient(
    circle,
    rgba(241, 255, 94, 0.22) 0%,
    rgba(58, 154, 255, 0.12) 50%,
    transparent 70%
  );
  top: 15%;
  right: 5%;
}

.hero-glow-orb--3 {
  animation-delay: -1.7s;
  width: 220px;
  height: 220px;
  background: radial-gradient(
    circle,
    rgba(38, 28, 193, 0.25) 0%,
    rgba(58, 154, 255, 0.1) 50%,
    transparent 70%
  );
  bottom: 5%;
  left: 15%;
}

@keyframes orbFloat {
  0% {
    transform: translate(0, 0) scale(1);
    opacity: 0.4;
  }
  22% {
    transform: translate(50px, -60px) scale(1.15);
    opacity: 0.55;
  }
  45% {
    transform: translate(-40px, 45px) scale(0.9);
    opacity: 0.45;
  }
  68% {
    transform: translate(60px, 40px) scale(1.08);
    opacity: 0.5;
  }
  85% {
    transform: translate(-20px, -30px) scale(1.02);
    opacity: 0.48;
  }
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.4;
  }
}

/* Shimmer - soldan sağa kayan ışık süpürme efekti */
.hero-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 35%,
    rgba(255, 255, 255, 0.06) 45%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.06) 55%,
    transparent 65%,
    transparent 100%
  );
  background-size: 60% 100%;
  background-repeat: no-repeat;
  animation: shimmerSlide 5s cubic-bezier(0.25, 0.1, 0.25, 1) infinite;
}

@keyframes shimmerSlide {
  0% {
    background-position: -60% 0;
  }
  35% {
    background-position: 80% 0;
  }
  70% {
    background-position: 120% 0;
  }
  100% {
    background-position: 160% 0;
  }
}

/* Dark mode için orb opaklıkları (body'deki landing-page-bg için) */
.landing-page-bg[data-theme="dark"] .hero-glow-orb {
  opacity: 0.35;
}

.landing-page-bg[data-theme="dark"] .hero-glow-orb--1 {
  background: radial-gradient(
    circle,
    rgba(58, 154, 255, 0.2) 0%,
    rgba(38, 28, 193, 0.08) 40%,
    transparent 70%
  );
}

.landing-page-bg[data-theme="dark"] .hero-glow-orb--2 {
  background: radial-gradient(
    circle,
    rgba(241, 255, 94, 0.12) 0%,
    rgba(58, 154, 255, 0.06) 50%,
    transparent 70%
  );
}

.landing-page-bg[data-theme="dark"] .hero-glow-orb--3 {
  background: radial-gradient(
    circle,
    rgba(91, 77, 255, 0.15) 0%,
    rgba(58, 154, 255, 0.05) 50%,
    transparent 70%
  );
}

.landing-page-bg[data-theme="dark"] .hero-light-rays {
  opacity: 0.6;
}

.landing-page-bg[data-theme="dark"] .hero-shimmer {
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 35%,
    rgba(255, 255, 255, 0.03) 50%,
    transparent 65%,
    transparent 100%
  );
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.2;
  margin: 0 0 24px 0;
  letter-spacing: -0.02em;
  transition: color 0.3s ease;
  animation: heroTitleFade 1s ease-out both;
}

@keyframes heroTitleFade {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-title-accent {
  display: inline-block;
  background: linear-gradient(
    135deg,
    var(--color-primary) 0%,
    var(--color-secondary) 70%,
    rgba(241, 255, 94, 0.4) 100%
  );
  color: white;
  padding: 0 12px;
  border-radius: 8px;
  margin-left: 4px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.hero-subtitle {
  font-size: 1.25rem;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto 40px;
  transition: color 0.3s ease;
  animation: heroTitleFade 1s ease-out 0.2s both;
}

.hero-cta {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  animation: heroTitleFade 1s ease-out 0.4s both;
}

/* Buttons */
.btn {
  display: inline-block;
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
}

.btn--primary {
  background: linear-gradient(
    135deg,
    var(--color-primary) 0%,
    var(--color-secondary) 100%
  );
  color: white;
  box-shadow: var(--shadow-card);
}

.btn--primary:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 32px rgba(58, 154, 255, 0.35),
    0 0 0 1px rgba(241, 255, 94, 0.2);
}

.btn--secondary {
  background: transparent;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
}

.btn--secondary:hover {
  background: var(--bg-cta);
  border-color: var(--color-secondary);
}

.btn--large {
  padding: 18px 40px;
  font-size: 18px;
}

/* Features */
.features {
  padding: 80px 0;
}

.features-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 48px 0;
  transition: color 0.3s ease;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.feature-card {
  background: var(--bg-card);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  transition: all 0.2s;
  border: 1px solid var(--border-card);
  box-shadow: var(--shadow-card);
}

.feature-card:hover {
  transform: translateY(-4px);
  background: var(--bg-card-hover);
  box-shadow: var(--shadow-card-hover);
}

.feature-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.feature-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 12px 0;
  transition: color 0.3s ease;
}

.feature-card p {
  font-size: 0.95rem;
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
  transition: color 0.3s ease;
}

/* CTA Section */
.cta-section {
  text-align: center;
  padding: 60px 20px;
  background: var(--bg-cta);
  border-radius: 20px;
  border: 1px solid var(--border-card);
  transition:
    background 0.3s ease,
    border-color 0.3s ease;
}

.cta-section h2 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 12px 0;
  transition: color 0.3s ease;
}

.cta-section p {
  font-size: 1.1rem;
  color: var(--text-secondary);
  margin: 0 0 24px 0;
  transition: color 0.3s ease;
}

/* Footer */
.landing-footer {
  padding: 24px;
  text-align: center;
  background: var(--bg-footer);
  border-top: 1px solid var(--border-card);
  transition:
    background 0.3s ease,
    border-color 0.3s ease;
}

.landing-footer-links {
  margin-bottom: 12px;
}

.landing-footer-links a {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 500;
  padding: 0 8px;
}

.landing-footer-links a:hover {
  text-decoration: underline;
}

.landing-footer .footer-sep {
  color: var(--text-muted);
  margin: 0 4px;
}

.landing-footer p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
  transition: color 0.3s ease;
}

/* Responsive */
@media (max-width: 640px) {
  .landing-header {
    padding: 16px 20px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .landing-main {
    padding: 40px 20px 60px;
  }

  .hero {
    padding: 20px 0 60px;
  }

  .hero-cta {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;;EAE5B,yEAAyE;EACzE,sCAAsC;EACtC,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;EAClC,mCAAmC;;EAEnC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,sCAAsC;EACtC,gDAAgD;EAChD,uDAAuD;AACzD;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;;EAE5B,yEAAyE;EACzE,kCAAkC;EAClC,gCAAgC;EAChC,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;;EAE/B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,wCAAwC;EACxC,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,2CAA2C;EAC3C;;0BAEwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA,SAAS;AACT;EACE,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,wFAAwF;AACxF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kDAAkD;EAClD;;;;;;;GAOC;EACD;;;;;;;GAOC;AACH;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,0BAA0B;EAC1B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAgCG;EACH,iEAAiE;EACjE,YAAY;AACd;;AAEA;EACE;IACE,qDAAqD;IACrD,aAAa;EACf;EACA;IACE,kDAAkD;IAClD,aAAa;EACf;EACA;IACE,mDAAmD;IACnD,aAAa;EACf;EACA;IACE,mDAAmD;IACnD,aAAa;EACf;EACA;IACE,mDAAmD;IACnD,YAAY;EACd;EACA;IACE,qDAAqD;IACrD,aAAa;EACf;AACF;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;;;;;GAKC;EACD,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb;;;;;GAKC;EACD,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb;;;;;GAKC;EACD,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,6CAA6C;IAC7C,aAAa;EACf;EACA;IACE,4CAA4C;IAC5C,aAAa;EACf;EACA;IACE,4CAA4C;IAC5C,YAAY;EACd;EACA;IACE,8CAA8C;IAC9C,aAAa;EACf;EACA;IACE,mCAAmC;IACnC,YAAY;EACd;AACF;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;;;;;GASC;EACD,yBAAyB;EACzB,4BAA4B;EAC5B,oEAAoE;AACtE;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,oEAAoE;AACpE;EACE,aAAa;AACf;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;;;;;;GAOC;AACH;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB;;;;;GAKC;EACD,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,8CAA8C;AAChD;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE;;;;GAIC;EACD,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B;;qCAEmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC;;0BAEwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;EACxC;;0BAEwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* ===== Renk Paleti =====\n   #1C0770 - Koyu mor/mavi (primary dark)\n   #261CC1 - Mavi (primary)\n   #3A9AFF - Açık mavi (secondary accent)\n   #F1FF5E - Sarı/limon (accent, vurgu)\n*/\n\n/* Light Mode (varsayılan) */\n.landing {\n  --color-primary-dark: #1c0770;\n  --color-primary: #261cc1;\n  --color-secondary: #3a9aff;\n  --color-accent: #f1ff5e;\n  --color-accent-text: #1a1a2e;\n\n  --bg-main: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 50%, #f5f9ff 100%);\n  --bg-header: rgba(255, 255, 255, 0.85);\n  --bg-card: rgba(255, 255, 255, 0.9);\n  --bg-card-hover: rgba(255, 255, 255, 1);\n  --bg-cta: rgba(58, 154, 255, 0.12);\n  --bg-footer: rgba(28, 7, 112, 0.08);\n\n  --text-primary: #1a1a2e;\n  --text-secondary: #4a4a6a;\n  --text-muted: #6b6b8a;\n\n  --border-card: rgba(38, 28, 193, 0.12);\n  --shadow-card: 0 4px 24px rgba(28, 7, 112, 0.08);\n  --shadow-card-hover: 0 8px 32px rgba(38, 28, 193, 0.15);\n}\n\n/* Dark Mode */\n.landing[data-theme=\"dark\"] {\n  --color-primary-dark: #5b4dff;\n  --color-primary: #6b5cff;\n  --color-secondary: #3a9aff;\n  --color-accent: #f1ff5e;\n  --color-accent-text: #0f0f14;\n\n  --bg-main: linear-gradient(135deg, #0f0f14 0%, #1a1a24 50%, #15151f 100%);\n  --bg-header: rgba(26, 26, 36, 0.9);\n  --bg-card: rgba(37, 37, 48, 0.8);\n  --bg-card-hover: rgba(45, 45, 60, 0.95);\n  --bg-cta: rgba(58, 154, 255, 0.15);\n  --bg-footer: rgba(0, 0, 0, 0.3);\n\n  --text-primary: #f0f0f5;\n  --text-secondary: #b8b8c8;\n  --text-muted: #8888a0;\n\n  --border-card: rgba(255, 255, 255, 0.08);\n  --shadow-card: 0 4px 24px rgba(0, 0, 0, 0.3);\n  --shadow-card-hover: 0 8px 32px rgba(58, 154, 255, 0.12);\n}\n\n/* Base */\n.landing {\n  position: relative;\n  z-index: 1;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-main);\n  transition: background 0.3s ease;\n}\n\n/* Header */\n.landing-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 40px;\n  background: var(--bg-header);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid var(--border-card);\n  transition:\n    background 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.landing-logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.landing-logo:hover {\n  opacity: 0.9;\n}\n\n.landing-logo-img {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.landing-nav {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.nav-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.nav-link:hover {\n  color: var(--color-primary);\n  background: var(--bg-cta);\n}\n\n.nav-link--primary {\n  background: var(--color-primary);\n  color: white;\n}\n\n.nav-link--primary:hover {\n  background: var(--color-primary-dark);\n  color: white;\n}\n\n/* Language Selector */\n.lang-selector {\n  position: relative;\n}\n\n.lang-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-card);\n  border-radius: 10px;\n  background: var(--bg-card);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.lang-trigger:hover {\n  border-color: var(--color-secondary);\n  background: var(--bg-cta);\n}\n\n.lang-trigger-flag {\n  font-size: 18px;\n}\n\n.lang-trigger-arrow {\n  font-size: 10px;\n  opacity: 0.7;\n  transition: transform 0.2s;\n}\n\n.lang-selector--open .lang-trigger-arrow {\n  transform: rotate(180deg);\n}\n\n.lang-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 180px;\n  margin: 0;\n  padding: 8px;\n  list-style: none;\n  background: var(--bg-card);\n  border: 1px solid var(--border-card);\n  border-radius: 12px;\n  box-shadow: var(--shadow-card-hover);\n  z-index: 100;\n}\n\n.lang-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n}\n\n.lang-option:hover {\n  background: var(--bg-cta);\n}\n\n.lang-option--active {\n  background: var(--bg-cta);\n  color: var(--color-primary);\n  font-weight: 600;\n}\n\n/* RTL (Arapça) */\n.landing--rtl .lang-trigger,\n.landing--rtl .lang-option {\n  text-align: right;\n}\n\n.landing--rtl .lang-dropdown {\n  left: auto;\n  right: 0;\n}\n\n.landing--rtl .hero-title-accent {\n  margin-left: 0;\n  margin-right: 4px;\n}\n\n/* Theme Toggle */\n.theme-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: var(--bg-cta);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 18px;\n}\n\n.theme-toggle:hover {\n  background: var(--color-secondary);\n  color: white;\n}\n\n/* Main */\n.landing-main {\n  flex: 1;\n  padding: 60px 40px 80px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Body seviyesinde animasyonlu arka plan - slogan alanına denk, yumuşak geçişle biter */\n.landing-page-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 75vh;\n  max-height: 720px;\n  pointer-events: none;\n  z-index: 10;\n  /* Keskin çizgi yerine profesyonel yumuşak geçiş */\n  mask-image: linear-gradient(\n    to bottom,\n    black 0%,\n    black 35%,\n    rgba(0, 0, 0, 0.85) 55%,\n    rgba(0, 0, 0, 0.5) 75%,\n    transparent 100%\n  );\n  -webkit-mask-image: linear-gradient(\n    to bottom,\n    black 0%,\n    black 35%,\n    rgba(0, 0, 0, 0.85) 55%,\n    rgba(0, 0, 0, 0.5) 75%,\n    transparent 100%\n  );\n}\n\n/* Hero */\n.hero {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n  padding: 40px 0 80px;\n}\n\n/* Işık ışınları - yukarıdan düşen ışık efekti */\n.hero-light-rays {\n  position: absolute;\n  inset: -30% -30% -30% -30%;\n  background:\n    /* Ana ışık konisi - yukarıdan aşağı */\n    radial-gradient(\n      ellipse 120% 80% at 50% -20%,\n      rgba(58, 154, 255, 0.18) 0%,\n      rgba(38, 28, 193, 0.08) 30%,\n      transparent 65%\n    ),\n    /* Yan ışık şeritleri */\n    linear-gradient(\n        105deg,\n        transparent 26%,\n        rgba(58, 154, 255, 0.12) 38%,\n        transparent 50%\n      ),\n    linear-gradient(\n      75deg,\n      transparent 21%,\n      rgba(38, 28, 193, 0.09) 33%,\n      transparent 45%\n    ),\n    linear-gradient(\n      90deg,\n      transparent 16%,\n      rgba(241, 255, 94, 0.06) 28%,\n      transparent 40%\n    ),\n    linear-gradient(\n      120deg,\n      transparent 31%,\n      rgba(58, 154, 255, 0.08) 43%,\n      transparent 55%\n    );\n  animation: lightRaysMove 7s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  opacity: 0.9;\n}\n\n@keyframes lightRaysMove {\n  0% {\n    transform: translateY(-15%) rotate(-3deg) scale(1.06);\n    opacity: 0.75;\n  }\n  18% {\n    transform: translateY(8%) rotate(4deg) scale(1.14);\n    opacity: 0.95;\n  }\n  38% {\n    transform: translateY(2%) rotate(-1deg) scale(1.08);\n    opacity: 0.85;\n  }\n  58% {\n    transform: translateY(15%) rotate(2deg) scale(1.12);\n    opacity: 0.95;\n  }\n  78% {\n    transform: translateY(-5%) rotate(-2deg) scale(1.1);\n    opacity: 0.8;\n  }\n  100% {\n    transform: translateY(-15%) rotate(-3deg) scale(1.06);\n    opacity: 0.75;\n  }\n}\n\n/* Parlayan orb'lar - yumuşak hareketli ışık noktaları */\n.hero-glow-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(70px);\n  opacity: 0.45;\n  animation: orbFloat 5.5s cubic-bezier(0.45, 0, 0.55, 1) infinite;\n}\n\n.hero-glow-orb--1 {\n  width: 320px;\n  height: 320px;\n  background: radial-gradient(\n    circle,\n    rgba(58, 154, 255, 0.35) 0%,\n    rgba(38, 28, 193, 0.15) 40%,\n    transparent 70%\n  );\n  top: -100px;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.hero-glow-orb--2 {\n  animation-delay: -0.9s;\n  width: 260px;\n  height: 260px;\n  background: radial-gradient(\n    circle,\n    rgba(241, 255, 94, 0.22) 0%,\n    rgba(58, 154, 255, 0.12) 50%,\n    transparent 70%\n  );\n  top: 15%;\n  right: 5%;\n}\n\n.hero-glow-orb--3 {\n  animation-delay: -1.7s;\n  width: 220px;\n  height: 220px;\n  background: radial-gradient(\n    circle,\n    rgba(38, 28, 193, 0.25) 0%,\n    rgba(58, 154, 255, 0.1) 50%,\n    transparent 70%\n  );\n  bottom: 5%;\n  left: 15%;\n}\n\n@keyframes orbFloat {\n  0% {\n    transform: translate(0, 0) scale(1);\n    opacity: 0.4;\n  }\n  22% {\n    transform: translate(50px, -60px) scale(1.15);\n    opacity: 0.55;\n  }\n  45% {\n    transform: translate(-40px, 45px) scale(0.9);\n    opacity: 0.45;\n  }\n  68% {\n    transform: translate(60px, 40px) scale(1.08);\n    opacity: 0.5;\n  }\n  85% {\n    transform: translate(-20px, -30px) scale(1.02);\n    opacity: 0.48;\n  }\n  100% {\n    transform: translate(0, 0) scale(1);\n    opacity: 0.4;\n  }\n}\n\n/* Shimmer - soldan sağa kayan ışık süpürme efekti */\n.hero-shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    transparent 35%,\n    rgba(255, 255, 255, 0.06) 45%,\n    rgba(255, 255, 255, 0.1) 50%,\n    rgba(255, 255, 255, 0.06) 55%,\n    transparent 65%,\n    transparent 100%\n  );\n  background-size: 60% 100%;\n  background-repeat: no-repeat;\n  animation: shimmerSlide 5s cubic-bezier(0.25, 0.1, 0.25, 1) infinite;\n}\n\n@keyframes shimmerSlide {\n  0% {\n    background-position: -60% 0;\n  }\n  35% {\n    background-position: 80% 0;\n  }\n  70% {\n    background-position: 120% 0;\n  }\n  100% {\n    background-position: 160% 0;\n  }\n}\n\n/* Dark mode için orb opaklıkları (body'deki landing-page-bg için) */\n.landing-page-bg[data-theme=\"dark\"] .hero-glow-orb {\n  opacity: 0.35;\n}\n\n.landing-page-bg[data-theme=\"dark\"] .hero-glow-orb--1 {\n  background: radial-gradient(\n    circle,\n    rgba(58, 154, 255, 0.2) 0%,\n    rgba(38, 28, 193, 0.08) 40%,\n    transparent 70%\n  );\n}\n\n.landing-page-bg[data-theme=\"dark\"] .hero-glow-orb--2 {\n  background: radial-gradient(\n    circle,\n    rgba(241, 255, 94, 0.12) 0%,\n    rgba(58, 154, 255, 0.06) 50%,\n    transparent 70%\n  );\n}\n\n.landing-page-bg[data-theme=\"dark\"] .hero-glow-orb--3 {\n  background: radial-gradient(\n    circle,\n    rgba(91, 77, 255, 0.15) 0%,\n    rgba(58, 154, 255, 0.05) 50%,\n    transparent 70%\n  );\n}\n\n.landing-page-bg[data-theme=\"dark\"] .hero-light-rays {\n  opacity: 0.6;\n}\n\n.landing-page-bg[data-theme=\"dark\"] .hero-shimmer {\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    transparent 35%,\n    rgba(255, 255, 255, 0.03) 50%,\n    transparent 65%,\n    transparent 100%\n  );\n}\n\n.hero-title {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  font-weight: 800;\n  color: var(--text-primary);\n  line-height: 1.2;\n  margin: 0 0 24px 0;\n  letter-spacing: -0.02em;\n  transition: color 0.3s ease;\n  animation: heroTitleFade 1s ease-out both;\n}\n\n@keyframes heroTitleFade {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hero-title-accent {\n  display: inline-block;\n  background: linear-gradient(\n    135deg,\n    var(--color-primary) 0%,\n    var(--color-secondary) 70%,\n    rgba(241, 255, 94, 0.4) 100%\n  );\n  color: white;\n  padding: 0 12px;\n  border-radius: 8px;\n  margin-left: 4px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.hero-subtitle {\n  font-size: 1.25rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0 auto 40px;\n  transition: color 0.3s ease;\n  animation: heroTitleFade 1s ease-out 0.2s both;\n}\n\n.hero-cta {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n  animation: heroTitleFade 1s ease-out 0.4s both;\n}\n\n/* Buttons */\n.btn {\n  display: inline-block;\n  padding: 14px 32px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.2s;\n  cursor: pointer;\n  border: none;\n}\n\n.btn--primary {\n  background: linear-gradient(\n    135deg,\n    var(--color-primary) 0%,\n    var(--color-secondary) 100%\n  );\n  color: white;\n  box-shadow: var(--shadow-card);\n}\n\n.btn--primary:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 32px rgba(58, 154, 255, 0.35),\n    0 0 0 1px rgba(241, 255, 94, 0.2);\n}\n\n.btn--secondary {\n  background: transparent;\n  color: var(--color-primary);\n  border: 2px solid var(--color-primary);\n}\n\n.btn--secondary:hover {\n  background: var(--bg-cta);\n  border-color: var(--color-secondary);\n}\n\n.btn--large {\n  padding: 18px 40px;\n  font-size: 18px;\n}\n\n/* Features */\n.features {\n  padding: 80px 0;\n}\n\n.features-title {\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 48px 0;\n  transition: color 0.3s ease;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.feature-card {\n  background: var(--bg-card);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 32px;\n  text-align: center;\n  transition: all 0.2s;\n  border: 1px solid var(--border-card);\n  box-shadow: var(--shadow-card);\n}\n\n.feature-card:hover {\n  transform: translateY(-4px);\n  background: var(--bg-card-hover);\n  box-shadow: var(--shadow-card-hover);\n}\n\n.feature-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.feature-card h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n  transition: color 0.3s ease;\n}\n\n.feature-card p {\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin: 0;\n  transition: color 0.3s ease;\n}\n\n/* CTA Section */\n.cta-section {\n  text-align: center;\n  padding: 60px 20px;\n  background: var(--bg-cta);\n  border-radius: 20px;\n  border: 1px solid var(--border-card);\n  transition:\n    background 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.cta-section h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n  transition: color 0.3s ease;\n}\n\n.cta-section p {\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  margin: 0 0 24px 0;\n  transition: color 0.3s ease;\n}\n\n/* Footer */\n.landing-footer {\n  padding: 24px;\n  text-align: center;\n  background: var(--bg-footer);\n  border-top: 1px solid var(--border-card);\n  transition:\n    background 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.landing-footer-links {\n  margin-bottom: 12px;\n}\n\n.landing-footer-links a {\n  color: var(--color-primary);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0 8px;\n}\n\n.landing-footer-links a:hover {\n  text-decoration: underline;\n}\n\n.landing-footer .footer-sep {\n  color: var(--text-muted);\n  margin: 0 4px;\n}\n\n.landing-footer p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n  transition: color 0.3s ease;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .landing-header {\n    padding: 16px 20px;\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .landing-main {\n    padding: 40px 20px 60px;\n  }\n\n  .hero {\n    padding: 20px 0 60px;\n  }\n\n  .hero-cta {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
